import Decimal from 'decimal.js';
import { RateType } from '@/connect';
import { FrontendOrder } from '@/connect/gen/modules/apiengine/services/oms/oms_pb';

/**
 * Check whether the order's rate matches the user-entered rate for the
 * selected rate type (fee or rebate). Used by the batch-modify dialog
 * to highlight unchanged rows.
 */
export function isOrderRateEqual(
  item: FrontendOrder,
  newRate: Decimal | null,
  rateType: RateType
): boolean {
  if (newRate === null) return false;
  const field = rateType === RateType.FEE ? item.fee : item.rebate;
  return field !== undefined && new Decimal(field).equals(newRate);
}
